import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  OptionReferenceCapabilities,
  OptionReferenceData,
} from '../options.model';

export interface OptionReferenceApi {
  readonly capabilities: OptionReferenceCapabilities;
  loadReferenceData(clientId: number | null): Observable<OptionReferenceData>;
}

export const OPTION_REFERENCE_API = new InjectionToken<OptionReferenceApi>(
  'OPTION_REFERENCE_API',
);
